<template>
  <div :id="`edit_category_${modalNumber}`"  class="modal fade rtl" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <p class="font-weight-bold">ویرایش دسته بندی</p>
        </div>
        <div class="modal-body">
          <form :id="`edit_category_form_${modalNumber}`" @submit.prevent="editCategory">
            <div class="form-group d-flex flex-column align-items-start">
              <label for="title">{{ $t('label.title') }}</label>
              <input type="text" class="form-control" name="title" v-model="title" >
            </div>
            <div class="form-group d-flex flex-column align-items-start">
              <label for="url">{{ $t('label.url') }}</label>
              <input type="text" class="form-control" name="url" v-model="url" >
            </div>
            <div class="form-group">
              <button :id="`edit_category_btn_${modalNumber}`" type="submit" class="btn btn-primary">
                {{ $t('btn.edit') }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ticketService} from "@/common/api.service";
import $ from "jquery";
import {KTApp} from "@/plugins/core/app";
import toastr from "toastr";

export default {
  name: "edit-category-modal",
  props: {
    modalNumber: {
      required: false,
      default: 'main_cat'
    },
    category: {
      required: true,
    }
  },
  computed: {
    toastr() {
      toastr.options = {
        closeButton: true,
        positionClass: "toast-bottom-center",
        preventDuplicates: false,
        rtl: false
      }

      return toastr
    },
  },
  data() {
    return {
      title: this.category.title,
      url: this.category.url,
    }
  },
  methods: {
    editCategory() {
      let form = $('#edit_category_form_'+ this.modalNumber)
      let btn = $('#edit_category_btn_'+ this.modalNumber)

      form.validate({
        ignore: ":hidden",
        rules: {
          title: {
            required: true
          },
          url: {
            required: true
          },
        }
      })

      if(!form.valid()) {
        return;
      }

      let data = {
        title: this.title,
        url: this.url,
        modalNumber: this.modalNumber
      }

      KTApp.progress(btn)

      ticketService.editCategory(this.category.id, data)
          .then(async (response) => {
            await this.$store.dispatch('ticket/fetchTicketCategories')
            $('#edit_category_' + this.modalNumber).modal('hide')
            this.toastr.success(response.data.message)
          })
          .catch(({response}) => {
            if (response.data) {
              form.validate().showErrors(response.data.data)
            }
            this.toastr.error(response.data.message)
          })
          .finally(() => {
            KTApp.unprogress(btn)
          })
    }
  }
}
</script>

<style scoped>

</style>